<template>
  <div class="list-items">
    <div class="list-item" v-for="(item, index) in listArr" :key="index" @click="toDetail">
      <img :src="item.path" alt="" class="img-item">
      <div class="item-content">
        <div style="font-size: 15px;margin-bottom: 10px;">{{ item.name }}</div>
        <div style="font-size: 15px;">{{ item.price }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import item1 from './../assets/images/90007/1.jpg'
import item2 from './../assets/images/90007/2.jpg'
import item3 from './../assets/images/90007/3.jpg'
import item4 from './../assets/images/90007/4.jpg'
import item5 from './../assets/images/90007/5.jpg'
import item6 from './../assets/images/90007/6.jpg'
import item7 from './../assets/images/90007/7.jpg'
import item8 from './../assets/images/90007/8.jpg'
import item9 from './../assets/images/90007/9.jpg'
import item10 from './../assets/images/90007/10.jpg'
import item11 from './../assets/images/90007/11.jpg'
import item12 from './../assets/images/90007/12.jpg'
import item13 from './../assets/images/90007/13.jpg'
import item14 from './../assets/images/90007/14.jpg'
import item15 from './../assets/images/90007/15.jpg'
import item16 from './../assets/images/90007/16.jpg'
import item17 from './../assets/images/90007/17.jpg'
export default {
  name: 'List',
  data() {
    return {
      listArr: [
        { name: '衣服1', price: '¥100.00', path: item1 },
        { name: '衣服2', price: '¥120.00', path: item2 },
        { name: '衣服3', price: '¥99.00', path: item3 },
        { name: '衣服4', price: '¥99.00', path: item4 },
        { name: '衣服5', price: '¥99.00', path: item5 },
        { name: '衣服6', price: '¥99.00', path: item6 },
        { name: '衣服7', price: '¥99.00', path: item7 },
        { name: '衣服8', price: '¥99.00', path: item8 },
        { name: '衣服9', price: '¥99.00', path: item9 },
        { name: '衣服10', price: '¥99.00', path: item10 },
        { name: '衣服11', price: '¥99.00', path: item11 },
        { name: '鞋子12', price: '¥99.00', path: item12 },
        { name: '衣服13', price: '¥99.00', path: item13 },
        { name: '鞋子14', price: '¥100.00', path: item14 },
        { name: '鞋子15', price: '¥99.00', path: item15 },
        { name: '衣服16', price: '¥99.00', path: item16 },
        { name: '鞋子17', price: '¥99.00', path: item17 },
      ]
    }
  },
  methods:{
    toDetail() {
      this.$router.push('/Detail')
    }
  }
}
</script>

<style lang="less" scoped>
.list-items {
  display: flex;
  flex-wrap: wrap;
  padding-top: 140px;
  position: relative;
  .list-item {
    width: 25vw;
    height: 25vw;
    background-color: transparent;
    position: relative;
    .item-content {
      position: absolute;
      left: 20px;
      bottom: 20px;
    }
  }
}
.img-item {
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>